window.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const footerTrigger = document.querySelector(".pulse-wrapper");
    const footer = document.querySelector(".klima-footer-bar");
    const pledgeSection = document.querySelector(".pledge-section");
    const newFooter = document.querySelector(".product-form-product-klima.sticky-buy");
    gsap.fromTo(
      footer,
      {
        opacity: 1,
        y: 0,
      },
      {
        scrollTrigger: {
          trigger: pledgeSection,
          start: "top bottom",
          end: "+=70px",
          scrub: 1,
          toggleActions: true,
        },
        opacity: 0,
        y: 70,
      },
    );
    gsap.fromTo(
      footer,
      { opacity: 0 },
      {
        scrollTrigger: {
          trigger: footerTrigger,
          start: "top bottom",
          end: "+=70px",
          scrub: true,
          toggleActions: true,
        },
        opacity: 1,
        duration: 0.2,
      },
    );
    // gsap.fromTo(
    //   newFooter,
    //   { opacity: 0 },
    //   {
    //     scrollTrigger: {
    //       trigger: footerTrigger,
    //       start: "top bottom",
    //       end: "+=70px",
    //       scrub: true,
    //       toggleActions: true,
    //     },
    //     opacity: 1,
    //     duration: 0.2,
    //   },
    // );
  }, 500);
});
